import { http } from 'services/http';
import { TRANSPORT_COST_PER_KM_GET } from 'api/query-keys.ts';
import type { TCreateTransportCostPerKmReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateTransportCostPerKm = () => {
  return useMutationBase<void, unknown, TCreateTransportCostPerKmReq>({
    mutationFn: async (variables) => {
      await http.post('/v1/transports/cost-per-km', variables);
    },
    invalidateCallback: () => [[TRANSPORT_COST_PER_KM_GET]],
  });
};
